module.exports = __webpack_public_path__ + "assets/img/005.31e4f6f4.png";